import { Analytics, AnalyticsBrowser } from '@segment/analytics-next';

export const analytics = new AnalyticsBrowser();

let isLoadingStarted = false;

export const isSegmentLoadingInProgress = () => {
  return isLoadingStarted;
};

export const initSegment = () => {
  if (!window.SEGMENT?.enabled) {
    return;
  }

  const isSegmentInitializedByRails = !!window.analytics;

  if (isSegmentInitializedByRails) {
    analytics.instance = window.analytics as unknown as Analytics;
    return;
  }

  if (!analytics.instance?.initialized && !isSegmentLoadingInProgress()) {
    isLoadingStarted = true;
    analytics.load({ writeKey: window.SEGMENT.jsKey }).finally(() => {
      isLoadingStarted = false;
    });
    analytics.page(window.location.pathname, {
      context: {
        screen: {
          height: window.screen.height,
          width: window.screen.width,
        },
      },
    });
  }
};
